import React from 'react'
import { useTranslation } from 'react-i18next'
import { alertsFilterList } from '../constants/AlertsConstants'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'

const ALERT_TAB_EVENTS = {
    all: ANALYTICS_EVENTS.ALERTS_ALL_VIEWED,
    keywordsDetected: ANALYTICS_EVENTS.ALERTS_KEYWORD_ALERTS_VIEWED,
    multipleNegativeEmotions: ANALYTICS_EVENTS.ALERTS_UNCOMFORTABLE_EMOTIONS_VIEWED,
}

function AlertsNavigationButtons({ selContent, setSelContent }) {
    const { t } = useTranslation()

    // Labels are built with t() rather than reused from AlertsConstants'
    // alertsListMap: that map calls i18n.t() at module load, so it would not
    // re-translate when the user switches language.
    const contentListMap = {
        all: t('All alerts'),
        keywordsDetected: t('Keyword alerts'),
        multipleNegativeEmotions: t('Uncomfortable emotions'),
    }
    useTrackedSurface(ALERT_TAB_EVENTS[selContent], { active: !!selContent })
    return (
        <div className="flex flex-row gap-[15px] ">
            {alertsFilterList.map((button, index) => {
                const isSelected = button === selContent
                return (
                    <SingleButton
                        button={button}
                        index={index}
                        isSelected={isSelected}
                        setSelContent={setSelContent}
                        contentListMap={contentListMap}
                        key={index}
                        id={`alert-button-${button}`}
                    />
                )
            })}
        </div>
    )
}

export default AlertsNavigationButtons

const SingleButton = ({ button, isSelected, index, setSelContent, contentListMap, id }) => {
    return (
        <button
            className={`rounded-[10px] px-[30px] h-[69px] bg-[#5E639B] relative xxs:flex flex-row items-center justify-center gap-1 hover:!bg-highlightColor hover:!text-deepPurple transition-all duration-[230ms] ease-in-out  ${
                button === 'myTask' ? 'xl:hidden' : ''
            } `}
            onClick={() => setSelContent(button)}
            style={{ backgroundColor: isSelected ? '#FDDF6D' : '#5E639B' }}
            key={index}
            id={id}
        >
            <div className={`dashboard-welcome-button ${isSelected ? 'text-deepPurple' : 'text-highlightColor'}`}>{contentListMap[button]}</div>
            {isSelected && <div className={`w-[22px] h-[22px] absolute rotate-45 -bottom-[9px] bg-[#FDDF6D] rounded-[2px] left-[50%] -translate-x-[50%]`}></div>}
        </button>
    )
}
